import {User, UserService} from "./app/services/user.service";
import {CanActivateFn, CanMatchFn, GuardResult, Router} from "@angular/router";
import {inject} from "@angular/core";
import {map, take} from "rxjs";

export const gotoLoginIfNotAuthenticated: (userStateToRoute: Partial<Record<User['status'], string[]>>) => CanActivateFn = (userStateToRoute) => (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.user$.pipe(
    take(1),
    map(user => {
      if (user.status === 'unauthorized') {
        return router.createUrlTree(['/login'], {queryParams: {redirectUrl: state.url}});
      }

      const stateRoute = userStateToRoute[user.status];
      if (stateRoute) {
        return router.createUrlTree(stateRoute);
      }

      return true;
    })
  );
}

export const gotoHomepageIfLoggedInGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.user$.pipe(
    take(1),
    map(user => {
      if (user.status === 'unauthorized') {
        return true; // Allow access to the route
      }

      // If the user is logged in, redirect to the homepage
      return router.createUrlTree(['/']);
    })
  );
}

export const postSignupFlowGuard: CanActivateFn = (route, state) => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.user$.pipe(
    take(1),
    map(user => {
      if (user.status === 'unauthorized') {
        return router.createUrlTree(['/login'], {queryParams: {redirectUrl: state.url}});
      }

      if (user.status === 'signup-flow') {
        return router.createUrlTree(['/']);
      }

      return true;
    })
  );
}


export const redirectOnUserState = (redirectFn: (router: Router, user: User) => GuardResult): CanActivateFn => () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.user$.pipe(
    take(1),
    map(user => {
      return redirectFn(router, user);
    })
  );
}

export const redirectIfUserNotInStates = (statuses: User['status'][], route = ['/']): CanActivateFn => redirectOnUserState((router, user) => {
    if (!statuses.includes(user.status)) {
      return router.createUrlTree(route);
    }

    return true;
  });

export const isUserInStates = (statuses: User['status'][]): CanMatchFn => () => {
  const userService = inject(UserService);

  return userService.user$.pipe(
    take(1),
    map(user => {
      console.log("Checking if user is in states", statuses, user.status);
      return statuses.includes(user.status);
    })
  );
}
